import axios, { AxiosRequestConfig } from 'axios';
import { PagedResponse } from '../types/api';

export interface MembershipCancelReason {
  id: number;
  code?: string;
  label: string;
}

const URL = '/v2/membership-cancel-reasons';

class MembershipCancelReasonsService {
  static getByFilter(config?: AxiosRequestConfig): Promise<PagedResponse<MembershipCancelReason>> {
    return axios.get(URL, config);
  }
}

export { MembershipCancelReasonsService };
